import { get } from 'lodash'

export default function(lastPersonalReflection, fields) {
  return {
    ...fields,
    personalReflection: get(lastPersonalReflection, 'personalReflection'),
    helpers: undefined
  }
}
